(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.home = {
    attach: function (context, settings) {

      
      if (getWithExpiry("home_animation") == null){
        $('body').addClass('first_visit');
        setWithExpiry("home_animation", true, 86400000);
      }

      function setWithExpiry(key, value, ttl) {
        var now = new Date()
  
        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        var item = {
          value: value,
          expiry: now.getTime() + ttl,
        }
        localStorage.setItem(key, JSON.stringify(item))
      }

      function getWithExpiry(key) {
        var itemStr = localStorage.getItem(key);
        // if the item doesn't exist, return null
        if (!itemStr) {
          return null;
        }

        var item = JSON.parse(itemStr);
        var now = new Date();
        
        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
          // If the item is expired, delete the item from storage
          // and return null
          localStorage.removeItem(key);
          return null;
        }
        return item.value;
      }
    }
  };

})(jQuery, Drupal, this, this.document);
